import PutyovkaWizard from './PutyovkaWizard';
import './PutyovkaWizard.css';

export default PutyovkaWizard;
